import React from "react";
import { FormattedMessage } from "react-intl";

const AGENT_TASK_STATE = {
  processing: "PROCESSING",
  completed: "COMPLETED",
  failed: "FAILED",
  canceled: "CANCELED",
};

const PROFILE_SECTIONS = [
  {
    name: <FormattedMessage id="Profile.ProfileResumeAutoFill.Section.Bio" />,
  },
  {
    name: <FormattedMessage id="Profile.ProfileResumeAutoFill.Section.Skills" />,
  },
  {
    name: <FormattedMessage id="Profile.ProfileResumeAutoFill.Section.Disciplines" />,
  },
  {
    name: <FormattedMessage id="Profile.ProfileResumeAutoFill.Section.Languages" />,
  },
  {
    name: <FormattedMessage id="Profile.ProfileResumeAutoFill.Section.Experience" />,
  },
  {
    name: <FormattedMessage id="Profile.ProfileResumeAutoFill.Section.Education" />,
  },
];

export default AGENT_TASK_STATE;

export { PROFILE_SECTIONS };
